module.exports = __webpack_public_path__ + "img/left.d828604e.svg";